export default __webpack_public_path__ + "alberta-checkbox-checked.fba8b43607818d2d7d35.svg";